<div class="row">
  <div class="col-sm-6" style="margin-top: 10px;">
    <h4>{{itemKeys?.length}} system<span *ngIf="itemKeys?.length !== 1">s</span> available</h4>
  </div>
  <div class="col-sm-6" style="padding-top: 10px;">
    <div class="text-right">
      <label style="margin-right: 10px;">Partly supported features:</label>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-primary" [class.active]="partlySupportedFeatures"
                (click)="setPartlySupportedFeatures(true)">
          <i class="fa fa-fw fa-check" aria-hidden="true"></i> Yes
        </button>
        <button type="button" class="btn btn-primary" [class.active]="!partlySupportedFeatures"
                (click)="setPartlySupportedFeatures(false)">
          <i class="fa fa-fw fa-times" aria-hidden="true"></i> No
        </button>
      </div>
    </div>
  </div>
</div>

<hr>

<div class="row">
  <div *ngIf="itemKeys?.length === 0">
    No systems for current selection.
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 item text-center"
       *ngFor="let item of itemKeys; let i = index;">
    <a class="card" href="{{items[item].url}}" target="_blank">
      <div class="card-img-top border-bottom" [ngStyle]="{'background-color': items[item]?.color}">
        <img src="{{items[item]?.url_pic}}" *ngIf="items[item]?.url_pic !== ''">
        <h4
          [class.text-light]="items[item]?.name_short === 'Eduvote' || items[item]?.name_short === 'Multiple Choice Generator' || items[item]?.name_short === 'MARS'"
          [class.small-font-size]="items[item]?.name_short === 'Multiple Choice Generator' || items[item]?.name_short === 'Blue Classroom Quiz'"
          *ngIf="items[item]?.url_pic === ''" style="margin-top: 10px;">{{items[item]?.name_short}}</h4>
      </div>
      <div class="card-body" [class.no-padding-left-right]="items[item]?.name_short === 'Multiple Choice Generator'">
        <div class="card-text">
          {{items[item]?.name_short}}
        </div>
      </div>
    </a>
  </div>
</div>
<!-- <div class="table-responsive" *ngIf="displayType === 'list'">
	<div *ngIf="itemKeys?.length === 0">
		No systems for current selection.
	</div>
	<table class="table" style="margin-top: 25px;">
		<tr *ngFor="let item of itemKeys; let i = index;">
			<td [ngStyle]="{'background-color': items[item]?.color}">
				<img src="{{items[item]?.url_pic}}" *ngIf="items[item]?.url_pic !== ''">
				<i class="fa fa-2x fa-times" *ngIf="items[item]?.url_pic === ''"></i>
			</td>
			<td [ngStyle]="{'background-color': items[item]?.color}" class="text-right">
				<a href="{{items[item].url}}" target="_blank" style="color: inherit;" class="text-light">{{items[item]?.name}}</a>
			</td>
		</tr>
	</table>
</div> -->

<!-- <hr>

<div class="row">
	<div class="col-12">
		<strong>Hints:</strong>
		<ul>
			<li>This list will be extended / refined continuously.</li>
			<li>Some systems will be removed and some systems will be added.</li>
		</ul>

		<strong>TODO:</strong>
		<ul>
			<li>Filter by subfunctions (graphics), sms and more complex infos like audience sizes.</li>
			<li>Different filter combinations: switch between AND & OR.</li>
			<li>Improve list coloring and make it responsive.</li>
			<li>Add search field.</li>
			<li>Add sorting options by names.</li>
			<li>Add star rating.</li>
		</ul>
	</div>
</div> -->
